import React, { useMemo } from 'react';

import { getEditor } from '../__code-container/utils';
import { Field } from '../__field/robot__field';
import { FieldBg } from '../__field/robot__field-bg';
import { RobotProblem } from '../robot.types';
import { useSkinForSample } from '../utils';
import { getVisibleSample } from '../utils/sample';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot__preview.module.scss';

interface Props {
    problem: RobotProblem;
    disableAnimation?: boolean;
}

export const RobotPreview = ({ problem: { markup, resources }, disableAnimation }: Props) => {
    const skin = markup.options.skin;
    const visibleSample = useMemo(() => getVisibleSample(markup), [markup]);
    const skinSample = useSkinForSample(skin?.samples, visibleSample?.index || 0);

    return (
        <FieldBg className={styles.preview} resources={resources} skin={skin}>
            {visibleSample && (
                <Field
                    disableAnimation={disableAnimation}
                    editor={getEditor(markup)?.editor ?? null}
                    field={visibleSample.field}
                    hideFinish={skin?.hide_finish}
                    resources={resources}
                    skin={skinSample}
                />
            )}
        </FieldBg>
    );
};

export default RobotPreview;
